// Lista de Precios Mar de Jade - Agosto 2025
// Productos del mar de la Patagonia

export interface ProductPrice {
  id: string;
  name: string;
  price: number;
  unit: string;
  category: string;
  description?: string;
  minimumOrder?: string;
  availability: 'disponible' | 'estacional' | 'agotado';
  origin: string;
  type: 'vivo' | 'fresco' | 'congelado' | 'precocido';
}

export const productPrices: ProductPrice[] = [
  // OSTRAS
  {
    id: 'ostras-docena',
    name: 'Ostras de cultivo calibradas vivas',
    price: 14000,
    unit: 'docena',
    category: 'ostras',
    description: 'Ostras de cultivo calibradas, vivas y frescas',
    availability: 'disponible',
    origin: 'Patagonia',
    type: 'vivo'
  },
  {
    id: 'ostras-media-docena',
    name: 'Ostras de cultivo calibradas vivas',
    price: 7500,
    unit: 'media docena',
    category: 'ostras',
    description: 'Ostras de cultivo calibradas, vivas y frescas',
    availability: 'disponible',
    origin: 'Patagonia',
    type: 'vivo'
  },
  {
    id: 'ostras-congeladas',
    name: 'Ostras congeladas media valva',
    price: 18000,
    unit: 'kg',
    category: 'ostras',
    description: 'Ostras congeladas en media valva',
    availability: 'disponible',
    origin: 'Patagonia',
    type: 'congelado'
  },

  // PULPO ESPAÑOL PREMIUM
  {
    id: 'pulpo-calibre-2-3',
    name: 'Pulpo Español Premium',
    price: 35000,
    unit: 'kg',
    category: 'pulpo',
    description: 'Calibre 2/3',
    availability: 'disponible',
    origin: 'España',
    type: 'fresco'
  },
  {
    id: 'pulpo-calibre-4-6',
    name: 'Pulpo Español Premium',
    price: 36000,
    unit: 'kg',
    category: 'pulpo',
    description: 'Calibre 4/6',
    availability: 'disponible',
    origin: 'España',
    type: 'fresco'
  },

  // PRODUCTOS PATAGONIA VIVOS/FRESCOS
  {
    id: 'almeja-blanca',
    name: 'Almeja blanca',
    price: 9000,
    unit: 'kg',
    category: 'mariscos-patagonia',
    availability: 'estacional',
    origin: 'Patagonia',
    type: 'vivo'
  },
  {
    id: 'navaja',
    name: 'Navaja',
    price: 19500,
    unit: 'kg',
    category: 'mariscos-patagonia',
    availability: 'estacional',
    origin: 'Patagonia',
    type: 'vivo'
  },
  {
    id: 'almeja-panopea',
    name: 'Almeja panopea',
    price: 12000,
    unit: 'kg',
    category: 'mariscos-patagonia',
    availability: 'estacional',
    origin: 'Patagonia',
    type: 'vivo'
  },
  {
    id: 'cholga',
    name: 'Cholga',
    price: 9000,
    unit: 'kg',
    category: 'mariscos-patagonia',
    availability: 'estacional',
    origin: 'Patagonia',
    type: 'vivo'
  },
  {
    id: 'vieira',
    name: 'Vieira',
    price: 14000,
    unit: 'kg',
    category: 'mariscos-patagonia',
    availability: 'estacional',
    origin: 'Patagonia',
    type: 'vivo'
  },
  {
    id: 'caracolito-globoso',
    name: 'Caracolito globoso',
    price: 10200,
    unit: 'kg',
    category: 'mariscos-patagonia',
    availability: 'estacional',
    origin: 'Patagonia',
    type: 'vivo'
  },

  // CENTOLLA
  {
    id: 'centolla-viva',
    name: 'Centolla viva',
    price: 42000,
    unit: '½kg',
    category: 'centolla',
    availability: 'estacional',
    origin: 'Patagonia',
    type: 'vivo'
  },

  // ESPECIALES CONGELADOS
  {
    id: 'centolla-pata',
    name: 'Centolla pata',
    price: 38000,
    unit: '½kg',
    category: 'centolla',
    availability: 'disponible',
    origin: 'Patagonia',
    type: 'congelado'
  },
  {
    id: 'centolla-mix',
    name: 'Centolla mix (pata/pulpa)',
    price: 85000,
    unit: 'kg',
    category: 'centolla',
    availability: 'disponible',
    origin: 'Patagonia',
    type: 'congelado'
  },
  {
    id: 'huevas-trucha-ikura',
    name: 'Huevas de trucha IKURA',
    price: 85000,
    unit: 'kg',
    category: 'huevas',
    availability: 'disponible',
    origin: 'Patagonia',
    type: 'congelado'
  },

  // PRODUCTOS FRESCOS/CONGELADOS
  {
    id: 'pulpito-tehuelche',
    name: 'Pulpito tehuelche',
    price: 35000,
    unit: 'kg',
    category: 'pulpo',
    availability: 'estacional',
    origin: 'Patagonia',
    type: 'fresco'
  },
  {
    id: 'cangrejo-volador',
    name: 'Cangrejo volador blanco',
    price: 19000,
    unit: 'kg',
    category: 'cangrejo',
    description: 'Entero, precocido, envasado al vacío',
    availability: 'estacional',
    origin: 'Patagonia',
    type: 'precocido'
  },
  {
    id: 'pulpa-ostra',
    name: 'Pulpa de ostra',
    price: 20000,
    unit: 'kg',
    category: 'ostras',
    description: 'Presentación: caja cerrada de 2 kilos',
    availability: 'disponible',
    origin: 'Patagonia',
    type: 'fresco'
  },
  {
    id: 'mejillon-beagle',
    name: 'Mejillón del Canal de Beagle',
    price: 12000,
    unit: 'kg',
    category: 'mejillones',
    description: 'Presentación: caja cerrada de 2 kilos',
    availability: 'estacional',
    origin: 'Canal de Beagle',
    type: 'congelado'
  },

  // LANGOSTINOS
  {
    id: 'langostino-pelado',
    name: 'Langostino pelado y desvenado',
    price: 24000,
    unit: 'kg',
    category: 'langostinos',
    availability: 'disponible',
    origin: 'Patagonia',
    type: 'congelado'
  },
  {
    id: 'langostino-entero',
    name: 'Langostino entero L1',
    price: 18000,
    unit: 'kg',
    category: 'langostinos',
    availability: 'disponible',
    origin: 'Patagonia',
    type: 'congelado'
  },
  {
    id: 'cola-langostino',
    name: 'Cola langostino a granel',
    price: 12000,
    unit: 'kg',
    category: 'langostinos',
    description: 'Congeladas, en sacos',
    availability: 'disponible',
    origin: 'Patagonia',
    type: 'congelado'
  },

  // ALGAS FRESCAS
  {
    id: 'algas-frescas-chubut',
    name: 'Algas frescas del Chubut',
    price: 11000,
    unit: 'kg',
    category: 'algas',
    description: 'Incluye variedades: Macrocystis, Nory, Undaria, Gracilaria, Lechuga de mar',
    minimumOrder: '3 kilos',
    availability: 'estacional',
    origin: 'Chubut',
    type: 'fresco'
  },
  {
    id: 'salicornia-fresca',
    name: 'Salicornia fresca',
    price: 13000,
    unit: 'kg',
    category: 'algas',
    minimumOrder: '4 kilos',
    availability: 'estacional',
    origin: 'Chubut',
    type: 'fresco'
  }
];

// Categorías para organización
export const productCategories = {
  'ostras': {
    name: 'Ostras',
    description: 'Ostras frescas de cultivo de la Patagonia',
    icon: '🦪',
    color: 'ocean'
  },
  'pulpo': {
    name: 'Pulpo',
    description: 'Pulpo premium español y patagónico',
    icon: '🐙',
    color: 'deep'
  },
  'mariscos-patagonia': {
    name: 'Mariscos Patagónicos',
    description: 'Mariscos vivos y frescos de la Patagonia',
    icon: '🦀',
    color: 'jade'
  },
  'centolla': {
    name: 'Centolla',
    description: 'Centolla viva y productos congelados',
    icon: '🦂',
    color: 'coral'
  },
  'huevas': {
    name: 'Huevas',
    description: 'Huevas de trucha IKURA premium',
    icon: '🥚',
    color: 'oyster'
  },
  'cangrejo': {
    name: 'Cangrejo',
    description: 'Cangrejo volador precocido',
    icon: '🦀',
    color: 'seagreen'
  },
  'mejillones': {
    name: 'Mejillones',
    description: 'Mejillones del Canal de Beagle',
    icon: '🐚',
    color: 'pearl'
  },
  'langostinos': {
    name: 'Langostinos',
    description: 'Langostinos patagónicos en diferentes presentaciones',
    icon: '🦐',
    color: 'coral'
  },
  'algas': {
    name: 'Algas',
    description: 'Algas frescas del Chubut',
    icon: '🌿',
    color: 'seagreen'
  }
} as const;

export type CategoryKey = keyof typeof productCategories;

// Términos y condiciones
export const termsAndConditions = {
  minimumDelivery: 25000,
  currency: 'CLP',
  lastUpdated: '2025-08-28',
  notes: [
    'Todos nuestros productos están sujetos a disponibilidad estacional',
    'Trabajamos con pesca artesanal y cultivos naturales',
    'Monto mínimo por entrega: $25.000',
    'Consultar por valores especiales en compras por mayor'
  ]
};

// Utilidades para formateo
export const formatPrice = (price: number): string => {
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    minimumFractionDigits: 0
  }).format(price);
};

export const getProductsByCategory = (category: string): ProductPrice[] => {
  return productPrices.filter(product => product.category === category);
};

export const searchProducts = (query: string): ProductPrice[] => {
  const lowercaseQuery = query.toLowerCase();
  return productPrices.filter(product => 
    product.name.toLowerCase().includes(lowercaseQuery) ||
    product.description?.toLowerCase().includes(lowercaseQuery) ||
    product.category.toLowerCase().includes(lowercaseQuery)
  );
};
